module.exports = __webpack_public_path__ + "img/cloud-hail-mixed.58d3c108.svg";